import "core-js/modules/es6.symbol.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
var _excluded = ["options", "price"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as types from './types';
import { fetchCustomizable } from '~/services/customizable';
export default {
  fetchConfigurator(_ref, _ref2) {
    var {
      commit
    } = _ref;
    var {
      model
    } = _ref2;
    var configuration = fetchCustomizable(this, model);
    var base = import('~/api/configurator/config.json');
    Promise.all([configuration, base]).then(values => {
      if (!values[0].status) {
        var {
          currentLocale
        } = this.state.i18n;
        var urlRedirect = values[1].details.backUrl;
        this.app.context.redirect("/".concat(currentLocale.market, "/").concat(currentLocale.language, "/e/").concat(urlRedirect) || '/');
      }
      var _values$0$payload = values[0].payload,
        {
          options,
          price
        } = _values$0$payload,
        information = _objectWithoutProperties(_values$0$payload, _excluded);
      commit(types.SET_DEFAULT_CUSTOMIZABLE, {
        options,
        price,
        model,
        information: _objectSpread(_objectSpread({}, information), values[1].details)
      });
      commit(types.SET_OPTIONS, options.map(option => _objectSpread(_objectSpread({}, option), {}, {
        config: values[1].config[option.name]
      })));
    }).catch(error => {
      this.$logger.error(error);
    });
  }
};